import { joinPath } from "../../utils/helpers";

export const PREVIEW_TICKET = "/events/ticket-holder";
export const PREVIEW_PROOF = "/events/proof-of-ticket";

export function getTicketEventsNavPaths(pathname) {
  const decoded = decodeURIComponent(pathname || "");

  const membersIdx = decoded.indexOf("/members/events/");
  if (membersIdx !== -1) {
    const prefix = decoded.slice(0, membersIdx);
    const base = joinPath(prefix || "/", "members/events");
    return {
      ticketHolder: joinPath(base, "ticket-holder"),
      proof: joinPath(base, "proof-of-ticket"),
    };
  }

  const eventsIdx = decoded.indexOf("/events/");
  if (
    eventsIdx !== -1 &&
    /\/events\/(ticket-holder|proof-of-ticket)\b/i.test(decoded)
  ) {
    const prefix = decoded.slice(0, eventsIdx);
    const base = joinPath(prefix || "/", "events");
    return {
      ticketHolder: joinPath(base, "ticket-holder"),
      proof: joinPath(base, "proof-of-ticket"),
    };
  }

  if (decoded.startsWith(PREVIEW_TICKET) || decoded.startsWith(PREVIEW_PROOF)) {
    return { ticketHolder: PREVIEW_TICKET, proof: PREVIEW_PROOF };
  }

  const siblingUnderscore = decoded.match(
    /^(.*)\/(ticket-holder|proof-of-ticket)\/?$/i,
  );
  if (siblingUnderscore) {
    const base = siblingUnderscore[1];
    return {
      ticketHolder: joinPath(base, "ticket-holder"),
      proof: joinPath(base, "proof-of-ticket"),
    };
  }

  const siblingHyphen = decoded.match(
    /^(.*)\/(ticket-holder|proof-of-ticket)\/?$/i,
  );
  if (siblingHyphen) {
    const base = siblingHyphen[1];
    return {
      ticketHolder: joinPath(base, "ticket-holder"),
      proof: joinPath(base, "proof-of-ticket"),
    };
  }

  return null;
}

function isProofOfTicketRoute(pathname) {
  const d = decodeURIComponent(pathname || "");
  return (
    /\/members\/events\/proof-of-ticket\/?$/i.test(d) ||
    /\/events\/proof-of-ticket\/?$/i.test(d) ||
    /\/proof-of-ticket\/?$/i.test(d)
  );
}

function isTicketHolderRoute(pathname) {
  const d = decodeURIComponent(pathname || "");
  return (
    /\/members\/events\/ticket-holder\/?$/i.test(d) ||
    /\/events\/ticket-holder\/?$/i.test(d) ||
    /\/ticket-holder\/?$/i.test(d)
  );
}

export { isProofOfTicketRoute, isTicketHolderRoute };
